import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { X } from 'react-feather'
import auth from '../utils/auth'

const ProfileCard = ({isOfficial}) => {
  return (
    <div className="flex items-center">
      <div
        style={{backgroundImage: `url('/images/logos/${isOfficial ? 'khub_peacegen.svg' : 'khub_anwar.jpg'}')`, height: '40px', width: '40px', backgroundSize: '60%', backgroundColor: '#f8f8f8'}}
        className="bg-no-repeat bg-center rounded-full mr-3"
      />
      <Link to="/dashboard/profile">
        <div>
          <p className="font-primary normal-case text-base font-bold">{isOfficial ? 'Peacegen ID' : 'Anwar Mustofa'}</p>
          <p className="font-primary normal-case font-normal text-xs text-gray-999">{isOfficial ? 'Official' : 'Verified'} Member</p>
        </div>
      </Link>
    </div>
  )
}

const HeaderMenu = ({setToggled, routes, language}) => {
  const { isOfficial, isVerified, isUser } = auth()
  const isAuth = isOfficial || isVerified || isUser
  const history = useHistory()

  const handleSignOut = () => {
    auth().logout()
    history.push('/login')
  }

  return (
    <div className="bg-white fixed overflow-y-auto scrolling-touch w-full h-screen left-0 top-0" style={{zIndex: 900}}>
      <div className={`flex justify-between p-5 border-b ${!isAuth ? 'items-center' : ''}`} style={{borderColor: '#ddd'}}>
        {
          isAuth &&
          <ProfileCard isOfficial={isOfficial} />
        }
        {
          !isAuth &&
          <Link to="/login">
            <h1 className="font-bold text-sm">Sign In</h1>
          </Link>
        }

        <div onClick={() => setToggled(false)}>
          <X className={`${isAuth ? 'mt-1' : ''}`}/>
        </div>
      </div>
      <div className="container mx-auto py-8 border-b" style={{borderColor: '#ddd'}}>
        <ul>
          {
            routes.map((r, i) => (
              <li className="mb-5" key={i}>
                <Link className="font-accent text-lg font-bold uppercase" to={r.path}>
                  {r.label[language]}
                </Link>
              </li>
            ))
          }
          {/* <li className="mb-5">
            <Link className="font-accent text-lg font-bold" to="/about">About Us</Link>
          </li>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold" to="/region-map">Peta Penanggulangan</Link>
          </li>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold" to="/resource">Products</Link>
          </li>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold" to="/event">Events</Link>
          </li>
          <li>
            <Link className="font-accent text-lg font-bold" to="/blog">Blog</Link>
          </li> */}
        </ul>
      </div>
      {
        isAuth &&
        <div className="container mx-auto py-8 border-b" style={{borderColor: '#ddd'}}>
          <ul>
            <li className="mb-5">
              <Link className="text-sm" to="/dashboard">Dashboard</Link>
            </li>
            <li className="mb-5">
              <Link className="text-sm" to="/dashboard/settings">Account Settings</Link>
            </li>
            <li className="mb-5">
              <p className="text-sm" onClick={handleSignOut}>Sign Out</p>
            </li>
          </ul>
        </div>
      }
      <div className="container mx-auto py-8">
        <div className="flex items-center">
          <div className="uppercase font-accent font-bold text-sm">Eng</div>
          <div className="uppercase font-accent font-bold text-sm text-gray-999 mx-2">/</div>
          <div className="uppercase font-accent font-bold text-sm text-gray-999">Ina</div>
        </div>
      </div>
    </div>
  )
}

export { HeaderMenu }
